import {IBook} from "@/interfaces/book.interface";

export namespace IParkEvent {
  export enum Action {
    FreeScheduleMake = 'FreeSchedule_MK',
  }

  export enum Command {
    Get = 'get',
    Set = 'set',
    EventsLog = 'EventsLog',
  }

  export interface IFilterEvents {
    enabled: boolean;
  }

  export interface IEntity {
    id: number;
    dateBeg: string;
    dateEnd: string;
    tSum: number;
    tSumAll: number;
    dateUpd: string;
    persName: string;
    parkName: string;
    comment?: string;
    enabled: boolean;
  }

  export enum PropType {
    Input = 'input',
    Password = 'password',
    Textarea = 'textarea',
    Select = 'select',
    Date = 'date',
    DateText = 'dateText',
    Text = 'text',
    NumberFormatted = 'numberFormatted',
    Custom = 'custom',
    SubProps = 'subProps',
    Actions = 'actions',
  }

  export interface ITableCell {
    propType: PropType;
    prop: string;
    placeholder?: string;
    label?: string;
    options?: IBook.CatalogData[];
    canCreate?: boolean;
    multiple?: boolean;
    titleProp?: string;
    subProps?: ITableCell[];
    numberSymbol?: string;
    inputType?: string;
  }

  export const DefaultParkEvent: IEntity = {
    id: null,
    dateBeg: '',
    dateEnd: '',
    tSum: null,
    tSumAll: null,
    dateUpd: '',
    persName: '',
    parkName: '',
    comment: '',
    enabled: true,
  };

  export interface ISaveParkEventPayload {
    formModel: IEntity;
    index: number;
    parkId: number;
    changeEnabled: boolean;
  }

  export enum EmitterEvents {
    ActivateNewRow = 'park-event:activate-new-row',
  }
}